import { DefaultButton, TextField } from '@fluentui/react';
import { UserRolesModel } from '../../../../accounts/models/UserRolesInfo';
import { textFieldStyles } from '../../../../common/views/DefaultStyles';
import { Utils } from '../../../../common/views/Utils';
import { PopUpType } from '../../../../home/models/OtherTypes';
import { ShortWebsiteModel } from '../../../../websites/models/WebsiteModel';
import WebsitePicker from '../../../../websites/views/WebsitePicker';
import { ChangeWebsiteOrderModel } from '../../../models/OrderModel';

type ChangeOrderWebsiteProps = {
    form: ChangeWebsiteOrderModel;
    userRoles: UserRolesModel;
    loading: boolean;
    options: ShortWebsiteModel[];
    onValueChange: (field: keyof ChangeWebsiteOrderModel, value: any) => void;
    onSubmit: () => void;
}

export default function ChangeOrderWebsiteView({
    form, userRoles, loading, options, onValueChange, onSubmit
}: ChangeOrderWebsiteProps) {
    const width6 = Utils.getColumnWidth(6);

    return <>
        <div className="ms-Grid-row">
            <div className={width6}>
                <WebsitePicker
                    type={PopUpType.modal}
                    onValueChange={(_, v) => onValueChange("websiteId", v || undefined)}
                    options={options}
                />
            </div>
            <div className={width6}>
                <TextField
                    label="Earning Points"
                    value={form.earningPointRate.toString()}
                    styles={textFieldStyles}
                    onChange={(_, v) => onValueChange("earningPointRate", v || 0)}
                />
            </div>
        </div>

        {userRoles.isSalesSupervisor && !loading && <div className="pt-15 right">
            <DefaultButton onClick={onSubmit}>Save Change</DefaultButton>
        </div>}
    </>;
}